import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up clone-deck" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "clone-deck-check" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Clone Deck", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "clone-deck-hint" }, "The new deck gets the same columns, tags, settings and users.", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("label", {
        class: "clone-deck-label",
        for: "clone-deck-name"
      }, "Name", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "clone-deck-name",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.submit()), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.name]
      ]),
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.includeCards) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.includeCards]
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Also clone all cards, with their checklists, comments and files", -1))
      ]),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: _ctx.disableButton ? 'Cloning...' : 'Clone',
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
      }, null, 10, _hoisted_5)
    ])
  ]))
}